// App Version Configuration
// This version is compared against the server's X-Admin-App-Version header
// to detect when a new frontend version is deployed

// Get version directly from package.json
export const APP_VERSION = require("../../../package.json").version;
